import { render } from "./InvoiceList.vue?vue&type=template&id=23127297&scoped=true"
import script from "./InvoiceList.vue?vue&type=script&lang=js"
export * from "./InvoiceList.vue?vue&type=script&lang=js"

import "./InvoiceList.vue?vue&type=style&index=0&id=23127297&lang=css"
import "./InvoiceList.vue?vue&type=style&index=1&id=23127297&scoped=true&lang=css"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23127297"]])

export default __exports__